const en = {
  title: 'DYNAVOX Inventory',
  subtitle: 'Sign in to manage your equipment',
  loginName: 'Login Name',
  password: 'Password',
  signIn: 'Sign In',
  signingIn: 'Signing in...',
  footer: '© {{year}} DYNAVOX. All rights reserved.',
};

const de = {
  title: 'DYNAVOX Inventar',
  subtitle: 'Melden Sie sich an, um Ihre Ausrüstung zu verwalten',
  loginName: 'Anmeldename',
  password: 'Passwort',
  signIn: 'Anmelden',
  signingIn: 'Anmeldung läuft...',
  footer: '© {{year}} DYNAVOX. Alle Rechte vorbehalten.',
};

const login = { en, de };
export default login;
